import css from "styled-jsx/css";

export const componentStyles = css`
  .plain-banner-component {
  }
`;
